export default __webpack_public_path__ + "static/media/spot-icon-first-search.bfed64f8.svg";